import React from 'react';
import util from '../util/util';
import api from '../api/api';
import EventEmitter from './publisher';

class Item extends React.Component {
    constructor(props){
        super(props)
        
        this.state = {
            itemData: props.itemData,
            hasAdBucks: props.itemData.HASADBUCKS > 0 ? true : false,
            AdStatus: props.itemData.ADSTATUS === 1 ? true : false
        }
        
    }
    
	deleteItem(e) {
		e.cancelBubble = true;
		let sendData = {
			method: 'SetItemJS',
			ItemID: this.props.itemData.ITEMID,
			Status: 3
		}
		api.StoreService(sendData).end((err, res) => {
			let result = JSON.parse(res.text);
			if(result.success === 1) {
				EventEmitter.dispatch('reloadItems', {update: true})
			} else {
				util.successFail.message('We had an Issue deleting your Item', 'error');
			}
		})
	}
	
    addClick(){
        if(this.props.itemData.ISAD){
			api.StoreService({method: "AddClick", ItemID: this.props.itemData.ITEMID})
                .end((err, res) => {
                var result = JSON.parse(res.text);
				window.location.href = "/itemDetails.cfm?itemID=" + this.props.itemData.ITEMID;
			});
		}else{
			window.location.href = "/itemDetails.cfm?itemID=" + this.props.itemData.ITEMID;
		}
    }
    
    showModal(){
        var modalInfo = {
            Name: this.props.itemData.SHOPOWNER,
            ReceiverID: this.props.itemData.ACCOUNTID
        }
        this.props.showModal(modalInfo);   
    }
    
	openEdit() {
		let editItemData = {
			popSource: '/myAccount/incEditItem.cfm?ItemID=' + this.props.itemData.ITEMID,
			popFrame: 'sdfgs',
			popTitle: 'Edit This Item',
			popBlurb: 'After making your changes, you can click "Save" or "Save and Publish"'
		}
		this.props.openEdit(editItemData);
	}
	
    setAd(adBool){
        
        let updateData = {
            method: "SetAd", 
            ItemID: this.props.itemData.ITEMID, 
            AdStatus: adBool
        }
		api.StoreService(updateData).end((err, res) => {
            var result = JSON.parse(res.text)
			if(result.success){
				if(adBool == 1){
					this.setState({AdStatus: true});
                }else{
					this.setState({AdStatus: false});
                }
			}
		});
    }
    
    render(){
        let ItemWidth = util.IsDefined(this.props.isHome) ? 'itemContainer col-3' : 'itemContainer col-4';
        let descirption = util.truncate(util.toText(this.props.itemData.ITEMDESCRIPTION), 90);
        let imageStyle = {backgroundImage: 'url('+this.props.itemData.IMAGEPATH+')'};
        let isAdClass = this.state.hasAdBucks && this.state.AdStatus ? 'isAd Advertising' : 'isAd';
        let isAdText = this.state.hasAdBucks && this.state.AdStatus ? 'Advertising' : 'Start Advertising';
        let setAdClick = this.state.hasAdBucks && this.state.AdStatus ? this.setAd.bind(this, 0) : this.setAd.bind(this, 1);
        let showAdvertising = this.state.hasAdBucks ? {display: 'block'} : {display: 'none'}
        let showAD = this.props.itemData.ISAD ? {display: 'block'} : {display: 'none'}
		
		let allowDelete = this.props.myItems && this.props.itemData.ACCOUNTID === user.accountID ? <i className="glyphicon glyphicon-remove deleteIcon" onClick={this.deleteItem.bind(this)}></i> : '';
		
        return(
            <div className={ItemWidth}>
                <div className="col-12">
					{allowDelete}
                    <a href="javascript: void()" onClick={this.addClick.bind(this)}>
                        <div className="itemImg" style={imageStyle} ></div>
                        <div className="itemTitle" onClick={this.addClick.bind(this)}>
                            {this.props.itemData.ITEMNAME}<br />
                            <span>{descirption}</span>
                        </div>
                        <div className="itemPrice">
                            {util.currencyFormat(this.props.itemData.PRICE)}
                        </div>
                    </a>
                    <Reviews Reviews={this.props.itemData.REVIEWS} Ratings={this.props.itemData.RATING} />
                    
                    <div className="isAd" style={showAD}>Advertisement</div>
                    <div className={isAdClass} style={showAdvertising} onClick={setAdClick}>{isAdText}</div>
                    <ItemButtons 
                        ItemID={this.props.itemData.ITEMID} 
                        Liked={this.props.itemData.LIKED} 
                        AccountID={this.props.itemData.ACCOUNTID} 
                        LikeID={this.props.itemData.LIKEID}
                        ISAD={this.props.itemData.ISAD}
                        showModal={this.showModal.bind(this)}
                        addClick={this.addClick.bind(this)}
                        myItems={this.props.myItems}
                        status={this.props.itemData.STATUS}
						openEdit={this.openEdit.bind(this)}/>
                </div>
            </div>
        )   
    }
}

class Reviews extends React.Component {
    constructor(props){
        super(props)
		
		this.state = {
			stars: [1,2,3,4,5]
		}
		
    }
	
	createStar(star, l){
		let starColor = star > Math.round(this.props.Ratings) ? '#666' : '#f25252';
		return <i key={l} className="glyphicon glyphicon-star" style={{color: starColor, fontSize: 11, marginRight: 5}}></i> 
	}
	
    render(){
		
        let hasReviews = (this.props.Reviews > 0);
        let starWidth = {width: this.props.Ratings * 20 +'%'};
        
        if(hasReviews){
            return (
                <div className="itemReviews">
                    Reviews: {this.props.Reviews}
                    <div className="stars">
						{this.state.stars.map(this.createStar.bind(this))}
                    </div>
                </div>
            )
        } else {
            return(
                <div className="itemReviews">
                    Be the First to Review this Item
                </div>
            )
        }
        
    }
}

class ItemButtons extends React.Component {
    constructor(props){
        super(props);
        
        this.state = {
            canMessage: (props.AccountID !== user.accountID),
            liked: props.Liked,
            likeID: props.LikeID,
            ItemID: props.ItemID,
            status: props.status
        }
    }
    
    like(){
        api.StoreService({method: 'AddLike', itemID: this.state.ItemID}).end((err, res) => {
			var result = JSON.parse(res.text);
			if(result.success = 1){
				this.setState({
					liked: true,
					likeID: result.LikeID
				});
			}
		});
    }
    
    unlike(){
        api.StoreService({method: 'SetLike', itemLikeID: this.state.likeID}).end((err, res) => {
			var result = JSON.parse(res.text);
			if(result.success = 1){
				this.setState({
					liked: false,
					likeID: null
				});
			}
		});
    }
    
    unpublishItem(itemID){
        let sendData = {
            action: 'unpublish', 
            ItemID: itemID, 
            Status: 0
        }
        api.General('/myAccount/actEditItem.cfm', sendData).end((err, res) => {
            if (res.ok) {
                this.setState({
                    status: 0
                });
            }
        });
        
    }
    
    publishItem(itemID){
        let sendData = {
            action: 'publish', 
            ItemID: itemID, 
            Status: 1
        }
            
        api.General('/myAccount/actEditItem.cfm', sendData).end((err, res) => {
            if (res.ok) {
                this.setState({
                    status: 1
                });
            }
        });
    }
    
    
    render(){
        let data = {
            ViewItem: (user.isLoggedIn ? 'col-6' : 'col-12') + ' ViewItem',
            messageColor: this.state.canMessage ? {color: ''} : {color: '#B3B3B3'},
            showLikeMessage: user.isLoggedIn ? {display: 'block'} : {display: 'none'},
            messageTooltip: this.props.AccountID !== user.accountID ? 'Message Shop Owner' : 'Sorry. You cannot send yourself a message.',
            messageLink: this.props.AccountID !== user.accountID ? this.props.showModal : '',
			
            wubClick: this.state.liked == 1 ? this.unlike : this.like,
            wubClass: this.state.liked == 1 ? 'col-3 active' : 'col-3',
            wubTooltip: this.state.liked ? 'WUBBED!!' : 'I WUB it!!',
            viewItemPink: (user.isLoggedIn ? 'col-6' : 'col-12') + ' pink ViewItem',
            viewItemGrey: (user.isLoggedIn ? 'col-6' : 'col-12') + ' lightGrey  ViewItem',
            viewItemBlue: (user.isLoggedIn ? 'col-6' : 'col-12') + ' blue ViewItem',
            publishLink: this.state.status ? this.unpublishItem.bind(this, this.props.ItemID) : this.publishItem.bind(this, this.props.ItemID),
            publishBtnClass: this.state.status ? (user.isLoggedIn ? 'col-6' : 'col-12') + ' lightGrey ViewItem' : (user.isLoggedIn ? 'col-6' : 'col-12') + ' pink ViewItem',
            publishText: this.state.status ? 'unpublish' : 'publish',
        }
        if(this.props.myItems){
            return(
                <ul className="itemBtns clearfix">
                    <li className={data.publishBtnClass} onClick={data.publishLink.bind(this)}>
                        {data.publishText}
                    </li>
                    <li className={data.viewItemBlue} onClick={this.props.openEdit.bind(this)}>
                        Edit Item
                    </li>
                </ul>
            )
        }else{
            return(
                <ul className="itemBtns clearfix">
                    <li className={data.ViewItem}>
                        <a href="javascript: void()" onClick={this.props.addClick.bind(this)}>View Item</a>
                    </li>
                    <li className="col-3 tooltip-bottom" style={data.showLikeMessage} data-tooltip={data.messageTooltip} onClick={data.messageLink}>
                        <i className="glyphicon glyphicon-envelope" style={data.messageColor}></i>
                    </li>
                    <li className={data.wubClass} style={data.showLikeMessage} onClick={data.wubClick.bind(this)}>
                        <i className="glyphicon glyphicon-heart"></i>
                    </li>
                </ul>
            )
        }
    }
}

Item.defaultProps = {
    myItems: false   
}

export default Item;


/** WEBPACK FOOTER **
 ** ./app/reusable/item.js
 **/